import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../Reveal";
import { PROCESS } from "../../lib/data";

function Step({ step, index }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.8", "start 0.35"] });
  const opacity = useTransform(scrollYProgress, [0, 1], [0.25, 1]);
  const x = useTransform(scrollYProgress, [0, 1], [40, 0]);

  return (
    <motion.div
      ref={ref}
      style={{ opacity, x }}
      data-testid={`process-step-${index}`}
      className="relative flex gap-6 pb-16 md:gap-10"
    >
      <div className="relative flex flex-col items-center">
        <div className="z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-gold/30 bg-ink text-gold">
          <step.icon className="h-6 w-6" strokeWidth={1.5} />
        </div>
      </div>
      <div className="pt-1">
        <span className="font-display text-sm font-semibold text-gold">{step.n}</span>
        <h3 className="mt-1 font-display text-2xl font-medium tracking-tight md:text-3xl">{step.title}</h3>
        <p className="mt-3 max-w-md text-white/55">{step.desc}</p>
      </div>
    </motion.div>
  );
}

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="process" data-testid="process-section" className="relative bg-ink-surface py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <Reveal><span className="text-xs font-bold uppercase tracking-[0.3em] text-gold">How It Works</span></Reveal>
              <Reveal delay={0.1}>
                <h2 className="mt-5 font-display text-4xl font-medium leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                  Four steps to a<br /> <span className="text-gradient-gold">smoother drive.</span>
                </h2>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="mt-6 max-w-sm text-white/55">
                  We've stripped the hassle out of car maintenance. Here's exactly what happens
                  from the moment you book.
                </p>
              </Reveal>
            </div>
          </div>

          <div ref={ref} className="relative lg:col-span-7">
            <div className="absolute left-8 top-0 h-full w-px bg-white/10">
              <motion.div style={{ height }} className="w-full bg-gradient-to-b from-[#FFF27A] to-[#FFD000]" />
            </div>
            <div className="relative">
              {PROCESS.map((s, i) => <Step key={s.n} step={s} index={i} />)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
